import React, { useMemo } from 'react';
import Image from 'react-bootstrap/Image';
import { useNavigate } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import store from '../store';
import { setIsAshford, setLocation } from '../store/bookingSlice';

import classes from './LocationCard.module.scss';

import ASH from '../assets/facility-images/ASH.png';
import defaultImage from '../assets/facility-images/ashford.png';
import BAR from '../assets/facility-images/BAR.png';
import GEP from '../assets/facility-images/GEP.png';
import LON from '../assets/facility-images/LON.png';
import MEL from '../assets/facility-images/MEL.png';
import NOR from '../assets/facility-images/NOR.png';
import PAR from '../assets/facility-images/PAR.png';
import { ReactComponent as IconStar } from '../assets/icon-star.svg';

interface Props {
    location: Location;
    ash?: boolean;
}

function LocationCard({ location, ash }: Props) {
    const navigate = useNavigate();

    const locationName = useMemo(() => {
        const name =
            location?.name.replace('U-Store-It', '').length > 1
                ? location?.name.replace('U-Store-It', '')
                : 'LSETUPS';
        if (ash && name === 'Keswick') {
            return 'Ashford';
        }
        return name;
    }, [ash, location?.name]);

    const image =
        {
            ASH: ASH,
            BAR: BAR,
            GEP: GEP,
            LON: LON,
            MEL: MEL,
            NOR: NOR,
            PAR: PAR,
        }[location.locationCode] ?? defaultImage;

    const googleRating =
        {
            ASH: 4.9,
            BAR: 4.9,
            GEP: 4.9,
            LON: 4.9,
            MEL: 4.9,
            NOR: 4.8,
            PAR: 4.9,
        }[location.locationCode] ?? 4.8;

    const addressLine = [location.address.address1, location.address.address2]
        .filter(Boolean)
        .join(' ');

    const goToLocation = () => {
        store.dispatch(setLocation(location));
        store.dispatch(setIsAshford(ash ? true : false));
        navigate(`/locations/${ash ? 'ashford' : location.slug}`);
    };

    return (
        <div
            className={`${classes.card} ${classes.expanded} ${classes.location}`}
            onClick={() => goToLocation()}
            data-location-name={locationName}
        >
            <Image src={ash ? defaultImage : image} className={classes.photo} />
            <div className={classes.cardBody}>
                <div className={`${classes.location_info_header}`}>
                    <span className={`${classes.location_name}`}>{locationName}</span>
                    <div>
                        <IconStar width={13} height={12.35} />
                        <span className={`${classes.rating}`}>{googleRating}</span>
                    </div>
                </div>
                <span className={`${classes.location_address}`}>
                    {addressLine}, {location.address.city}, {location.address.region}{' '}
                    {location.address.postalCode}
                </span>
                <a onClick={() => goToLocation()} className='hidden-link'>
                    <button>
                        <span>Select Location</span>
                    </button>
                </a>
            </div>
        </div>
    );
}

export default LocationCard;
